import Emitter from "es6-event-emitter";
import dictionary from "../../../common/dictionary";
import {
  generateSecurePreviewURL,
  isSinglePage,
  requiredParam,
} from "../../../common/utilities/utils";
import { CLICKED_PRINT_READER } from "./../../../common/analytics/analyticsevents";
import { PAGE_POSITION_TYPE } from "./../../../common/interfaces/page.interface";
import CropperComponent from "./../components/cropperComponent";
import template from "./../templates/printMenuComponent.dust";

export default class PrintMenuComponent extends Emitter {
  constructor(
    DOMContainer = requiredParam("DOMContainer"),
    pubStore,
    appState,
    options,
    sessionManager
  ) {
    super();
    this._DOMContainer = DOMContainer;
    this._pubStore = pubStore;
    this._appState = appState;
    this._options = options;
    this._sessionManager = sessionManager;
    this.render();
  }

  render() {
    const context = {
      i18n: dictionary,
      printCroppedPdf: this._options.print.printCroppedPdf,
      isSingle: isSinglePage(this._appState),
    };
    Dust.render(template, context, (err, result) => {
      this._DOMContainer.innerHTML = result;
      this._attatchClickHandlers();
    });
  }

  _attatchClickHandlers() {
    this._appState.on("appState:currentpagechanged", this._resetMenu);
    this._appState.on("alb:overlayClicked", this._hideMenu);
    this._appState.on("cropper:overlayClicked", this._hideMenu);
    this._appState.on("readerContainer:clicked", this._hideMenu);
    this._appState.on("downloadButton:clicked", this._hideMenu);
    this._appState.on("categoryDropdown:opened", this._hideMenu);
    this._appState.on("settingButton:clicked", this._hideMenu);
    this._appState.on("readerReadingMode:clicked", this._hideMenu);
    const printItems = this._DOMContainer.querySelectorAll(
      ".print-cropped-item"
    );
    printItems.forEach((item) => {
      const print = item.getAttribute("data-print");
      item.addEventListener("click", (e) => {
        e.stopPropagation();
        const currentPages = this._pubStore.getCurrentPages(
          this._appState.currentPage
        );
        switch (print) {
          case "printSinglePage":
            this._appState.triggerEvent(CLICKED_PRINT_READER);
            if (
              currentPages.left == null ||
              (currentPages.right &&
                [PAGE_POSITION_TYPE.FRONT, PAGE_POSITION_TYPE.BACK].includes(
                  currentPages.right.PagePositionType
                ))
            ) {
              this._openPage(this._prepareImageUrl(currentPages.right));
            } else {
              this._openPage(this._prepareImageUrl(currentPages.left));
            }
            break;
          case "printLeftPage":
            this._appState.triggerEvent(CLICKED_PRINT_READER);
            this._openPage(this._prepareImageUrl(currentPages.left));
            break;
          case "printRightPage":
            this._appState.triggerEvent(CLICKED_PRINT_READER);
            this._openPage(this._prepareImageUrl(currentPages.right));
            break;
          default:
        }
      });
    });
  }

  _openPage(pageUrl) {
    this.toggleMenu();
    if (!this._cropperOverlay) {
      this._cropperOverlay = document.querySelector("#cropper");
    }
    this.cropComponent = new CropperComponent(
      this._cropperOverlay,
      this._appState,
      this._options
    );
    this.cropComponent.loadImage(pageUrl);
  }

  _resetMenu = () => {
    this._removeClickHandlers();
    this.render();
  };

  toggleMenu() {
    this._DOMContainer.classList.toggle("hidden");
  }

  _hideMenu = () => {
    if (!this._DOMContainer.classList.contains("hidden")) {
      this._DOMContainer.classList.add("hidden");
    }
  };

  _prepareImageUrl(page) {
    if (!page) return null;
    const { userId, sessionId, downloadId } = this._appState;
    return generateSecurePreviewURL(
      this._options.print.imageSize,
      page.PublicationPageID,
      sessionId,
      userId,
      downloadId
    );
  }

  _removeClickHandlers() {
    this._appState.off("appState:currentpagechanged", this._resetMenu);
    this._appState.off("alb:overlayClicked", this._hideMenu);
    this._appState.off("cropper:overlayClicked", this._hideMenu);
    this._appState.off("readerContainer:clicked", this._hideMenu);
    this._appState.off("downloadButton:clicked", this._hideMenu);
    this._appState.off("categoryDropdown:opened", this._hideMenu);
    this._appState.off("settingButton:clicked", this._hideMenu);
    this._appState.off("readerReadingMode:clicked", this._hideMenu);
    const printItems = this._DOMContainer.querySelectorAll(
      ".print-cropped-item"
    );
    printItems.forEach((item) => {
      const print = item.getAttribute("data-print");
      item.removeEventListener("click", (e) => {
        e.stopPropagation();
        const currentPages = this._pubStore.getCurrentPages(
          this._appState.currentPage
        );
        switch (print) {
          case "printSinglePage":
            if (currentPages.left == null) {
              this._openPage(this._prepareImageUrl(currentPages.right));
            } else {
              this._openPage(this._prepareImageUrl(currentPages.left));
            }
            break;
          case "printLeftPage":
            this._openPage(this._prepareImageUrl(currentPages.left));
            break;
          case "printRightPage":
            this._openPage(this._prepareImageUrl(currentPages.right));
            break;
          default:
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/web/reader/components/printMenuComponent.js